import { makeStyles } from "@material-ui/core";
import { createStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";
import { ArrowDownIcon, ArrowUpIcon, Text } from "../..";

import { baseColors, RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            pill: {
                display: "flex",
                alignItems: "center",
                height: "max-content",
                padding: "0px 8px 0px 8px",
            },
            amount: {
                fontSize: 12,
            },
            arrow: {
                paddingRight: 4,
                fontSize: 14,
            },
            positive: {
                color: "#4CAF50",
            },
            negative: {
                color: baseColors.danger_red,
            },
        }),
    { name: "AmountChangePill" }
);

interface InnerAmountChangeProps {
    amountChange?: number;
    amountType: "dollar" | "percent";
}

export const AmountChangePill = (props: InnerAmountChangeProps) => {
    const { amountChange, amountType } = props;

    const classes = useStyles({});

    if (!amountChange) return null;

    const getAmountWithSymbol = () => {
        let amount = amountChange;
        if (amountChange < 0) amount = amountChange * -1;

        if (amountType === "dollar") return `$${amount}`;

        return `${amount}%`;
    };

    return amountChange > -1 ? (
        <div className={classes.pill}>
            <ArrowUpIcon
                className={classnames(classes.positive, classes.arrow)}
                fontSize="small"
            />
            <Text className={classes.amount}>{getAmountWithSymbol()}</Text>
        </div>
    ) : (
        <div className={classes.pill}>
            <ArrowDownIcon
                className={classnames(classes.negative, classes.arrow)}
                fontSize="small"
            />
            <Text className={classes.amount}>{getAmountWithSymbol()}</Text>
        </div>
    );
};
